import React from "react";
import HeroSection from "../components/HeroSection";

function Home() {
  return (
    <div className="home">
      <HeroSection />
    </div>
  );
}

export default Home;
